module.exports = __webpack_public_path__ + "static/media/cafe24-case2.6c88939e.png";